import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import PublicLayoutContainer from './containers/PublicLayoutContainer';
import AuthLayoutContainer from './containers/AuthLayoutContainer';
import DashboardLayoutContainer from './containers/DashboardLayoutContainer';
import ProfileContainer from './containers/ProfileContainer';
import LoginContainer from './containers/LoginContainer';
import SignUp from './components/pages/login/SignUp';
import PublicHome from './components/public/home';
import OpenHome from './components/public/open';
import AuthHome from './components/auth/home';
import NoMatch from './components/notFound';
import Dashboard from './components/dashboard/index';
import Profile from './components/profile/home';
import ProcessPayment from './components/pages/process-payment';
import AOS from 'aos';
import ForgotPasswordContainer from './containers/ForgotPasswordContainer';
import SetPasswordContainer from './containers/SetPasswordContainer';
import UaePassCallBack from './components/pages/login/UaePassCallBack';

const RouteWithLayout = ({ layout: Layout, component: Component, isPrivate, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        const user = localStorage.getItem('user');
        const parsedUser = user ? JSON.parse(user) : null;
        const isLoggedIn = parsedUser && parsedUser.email;

        const isAuthException =
          props.location.pathname.includes("/app/forgotpassword") ||
          props.location.pathname.includes("/app/setpassword") ||
          props.location.pathname.includes("/public/link") ||
          window.location.href.includes("://app")


        if (isPrivate && !isLoggedIn) {
          return <Redirect to="/login" />;
        }

        if (!isPrivate && isLoggedIn && !isAuthException) {
          return <Redirect to="/app" />;
        }

        return React.createElement(
          Layout,
          props,
          React.createElement(Component, props)
        );
      }}
    />
  );
};

class App extends Component {

  componentDidMount() {
    AOS.init();
  }

  render() {
    let totalQuantityAdded = 0;
    const globalOrderItems = localStorage.getItem('orderitems');


    if (globalOrderItems) {
      const parsedData = JSON.parse(globalOrderItems);
      totalQuantityAdded = parsedData ? parsedData.length : 0;
    }

    return (
      <div className="neene-player-app h-100">
        <Switch>

          <Route exact path="/">
            <Redirect to="/login" />
          </Route>

          <RouteWithLayout
            layout={PublicLayoutContainer}
            exact
            path="/login"
            component={PublicHome}
          />

          <RouteWithLayout
            layout={PublicLayoutContainer}
            path="/open"
            component={OpenHome}
          />

          <RouteWithLayout
            layout={PublicLayoutContainer}
            exact
            path="/public/link/:linkId"
            component={PublicHome}
          />

          <Route path="/processpayment" component={ProcessPayment} />
          <Route path="/welcome" component={LoginContainer} />
          <Route path="/app/signup" component={SignUp} />
          <Route path="/app/forgotpassword" component={ForgotPasswordContainer} />
          <Route path="/app/setpassword/:reflink" component={SetPasswordContainer} />
          <Route path="/processgateway" component={UaePassCallBack} />

          <Switch>

            <RouteWithLayout
              layout={AuthLayoutContainer}
              path="/app"
              component={AuthHome}
              isPrivate
            />

            <RouteWithLayout
              layout={DashboardLayoutContainer}
              path="/dashboard"
              component={Dashboard}
              isPrivate
            />

            <RouteWithLayout
              layout={ProfileContainer}
              path="/profile"
              component={Profile}
              isPrivate
            />

            <Route path='*' component={NoMatch} />

          </Switch>

        </Switch>
      </div>
    );
  }
}

export default App;